import React, {useMemo} from 'react';
import {useTable, usePagination, useSortBy, useGlobalFilter} from "react-table";
import {COLUMNS} from "./columns/confirmGradesColumns";
import './table.scss';
import Grade from "../Grade/Grade";
import MoreTableButton from "../../ui-components/MoreTableButton/MoreTableButton";

function ConfirmGrades({data, courseLevel, amendGrade}) {

    const columns = useMemo(() => COLUMNS, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow
    } = useTable({
        columns: columns,
        data: data,
        initialState: { pageSize: 9999 }
    }, useGlobalFilter, useSortBy, usePagination);

    function cellContentHandler(columnTitle, content, percentage, id){

        //Percentage
        if(columnTitle === "Percentage"){
            return(
                <>
                    {percentage}%
                </>
            )
        }

        //Grade
        if(columnTitle === "Grade"){
            return(
                <Grade
                    percent={percentage}
                    courseLevel={courseLevel}
                />
            )
        }

        //Amend
        if(columnTitle === "Amend"){
            return(
                <MoreTableButton
                    onClick={() => amendGrade(id)}
                >
                    Amend
                </MoreTableButton>
            )
        }
        return content
    }

    return (
        <div className={'table_container'}>
            <div className={'table_container_padding'}>
                <table style={{marginBottom: "0.5rem"}} {...getTableProps()}>
                    <thead>
                    {headerGroups.map((headerGroup, i) =>(
                        <tr {...headerGroup.getHeaderGroupProps} key={i}>
                            {headerGroup.headers.map((column, i) => (
                                <th {...column.getHeaderProps(column.getSortByToggleProps())} key={i}>
                                    {column.render('Header')}
                                    <span>
                                    {column.isSorted
                                        ? column.isSortedDesc
                                            ? ' 🔽'
                                            : ' 🔼'
                                        : ''}
                                </span>
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page.map(row => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {

                                    return <td{...cell.getCellProps()} key={cell.getCellProps().key}>
                                        {cellContentHandler(cell.column.Header, cell.render('Cell'), row.original.percent, row.original.id)}
                                    </td>
                                })}
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ConfirmGrades;